<div class="action-logs" [class.loading-blur]="loading$.getValue()" [class.loading-row]="loading$.getValue()">
  <table class="table">
    <thead>
      <tr>
        <th class="align-left">Tilknytning</th>
        <th class="align-left">Status</th>
        <th class="align-left">Tidspunkt</th>
        <th class="align-left">Ændring</th>
        <th class="align-left">Udført af</th>
      </tr>
    </thead>
    <tbody>
      @if (actionLogs.length === 0) {
        <tr>
          <td colspan="5" class="text-center">
            <p>Der er ingen hændelser</p>
          </td>
        </tr>
      }
      @for (logEvent of actionLogs; track logEvent) {
        <tr>
          <td class="organization no-wrap">
            @if (!logEvent.organizationId) {
              <mat-icon>public</mat-icon>
              <span>Global pris</span>
            }
            @if (logEvent.organizationId) {
              <mat-icon svgIcon="business" aria-hidden="false"></mat-icon>
              <span>{{ logEvent.organizationName }}</span>
            }
          </td>
          <td>{{ logEvent.eventType | translateActionLogStatusEnum }}</td>
          <td class="no-wrap">{{ logEvent.created | date: 'short' }}</td>
          <td [innerHTML]="logEvent.message | slice: 0 : 200"></td>
          <td>
            <span class="icon-with-text">
              {{ logEvent.createdBy }}
              @if (logEvent.note) {
                <mat-icon class="margin--left-s align-right" svgIcon="note" [matTooltip]="logEvent.note" />
              }
            </span>
          </td>
        </tr>
      }
    </tbody>
  </table>
  <mat-paginator
    #paginator
    [style.visibility]="actionLogCount ? 'visible' : 'hidden'"
    [pageIndex]="currentPage"
    [pageSize]="pagingOptions.pageSize"
    [length]="actionLogCount"
    [pageSizeOptions]="pagingOptions.pageSizeOptions"
    (page)="onPageChanged($event)"
    color="accent"
    [disabled]="(loading$ | async) === true" />
</div>
